// import React, { useState, useEffect } from "react";
// import {
//   Star,
//   ShoppingCart,
//   Heart,
//   Share2,
//   Truck,
//   Shield,
//   Clock,
//   ChevronLeft,
//   ChevronRight,
//   Plus,
//   Minus,
//   Info,
//   AlertCircle,
//   CheckCircle,
// } from "lucide-react";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// const OtcProductIndividualpage = () => {
//   const { id } = useParams();
//   const [productData, setProductData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(0);
//   const [quantity, setQuantity] = useState(1);
//   const [activeTab, setActiveTab] = useState("description");
//   const [showFullDescription, setShowFullDescription] = useState(false);

//   // Mock API call - replace with actual API endpoint
//   useEffect(() => {
//     const fetchProductData = async (id) => {
//       try {
//         // Simulating API call delay

//         try {
//           const res = await axios.get(
//             `https://api.medstown.com/api/medshubs/otc-product/${id}`
//           );
//           console.log(res.data?.data);
//           setProductData(res.data?.data);
//           setLoading(false);
//         } catch (error) {
//           console.error("Error fetching drug:", error);
//         } finally {
//           setLoading(false);
//         }
//         // await new Promise((resolve) => setTimeout(resolve, 1000));

//         // Using the provided data structure
//         // const mockResponse = {
//         //   success: true,
//         //   status: 200,
//         //   message: "Product details fetched successfully",
//         //   data: {
//         //     detailJson: {
//         //       skus: {
//         //         name: "i-pill Tablet | Emergency Contraceptive for Women",
//         //         id: 59283,
//         //         url: "/otc/i-pill-tablet-emergency-contraceptive-for-women-otc59283",
//         //         price: 75.35,
//         //         discountedPrice: 75,
//         //         discountPercent: null,
//         //         initialDiscountedPrcie: 75,
//         //         tax_inclusion_text: "Inclusive of all taxes",
//         //         images: [
//         //           {
//         //             thumbnail:
//         //               "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/8ac7208c858543569bc5197c7488819d.jpg",
//         //             medium:
//         //               "https://onemg.gumlet.io/l_watermark_346,w_480,h_480/a_ignore,w_480,h_480,c_fit,q_auto,f_auto/8ac7208c858543569bc5197c7488819d.jpg",
//         //             high: "https://onemg.gumlet.io/l_watermark_346,w_690,h_700/a_ignore,w_690,h_700,c_pad,q_auto,f_auto/8ac7208c858543569bc5197c7488819d.jpg",
//         //           },
//         //           {
//         //             thumbnail:
//         //               "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/b6019cafcdc1423a9af3a6435b72ee34.jpg",
//         //             medium:
//         //               "https://onemg.gumlet.io/l_watermark_346,w_480,h_480/a_ignore,w_480,h_480,c_fit,q_auto,f_auto/b6019cafcdc1423a9af3a6435b72ee34.jpg",
//         //             high: "https://onemg.gumlet.io/l_watermark_346,w_690,h_700/a_ignore,w_690,h_700,c_pad,q_auto,f_auto/b6019cafcdc1423a9af3a6435b72ee34.jpg",
//         //           },
//         //           {
//         //             thumbnail:
//         //               "https://onemg.gumlet.io/l_watermark_346,w_120,h_120/a_ignore,w_120,h_120,c_fit,q_auto,f_auto/53ebd6f161bf4de39a28099655a88d6b.jpg",
//         //             medium:
//         //               "https://onemg.gumlet.io/l_watermark_346,w_480,h_480/a_ignore,w_480,h_480,c_fit,q_auto,f_auto/53ebd6f161bf4de39a28099655a88d6b.jpg",
//         //             high: "https://onemg.gumlet.io/l_watermark_346,w_690,h_700/a_ignore,w_690,h_700,c_pad,q_auto,f_auto/53ebd6f161bf4de39a28099655a88d6b.jpg",
//         //           },
//         //         ],
//         //         standardPackLabel: "strip of 1 Tablet",
//         //         standardPack: "1 Tablet",
//         //         marketer: {
//         //           name: "Piramal Enterprises Ltd",
//         //           address:
//         //             "Piramal Enterprises Limited, Piramal Ananata, Agastya Corporate Park, 109 A, 109A/1 to 109/21A, 111 and 110, 110/1 to 110/13, Opposite Fire Brigade, Kamani Junction, Kurla (West), Mumbai 400070, Maharashtra, India",
//         //         },
//         //         description: {
//         //           header:
//         //             "Information about i-pill Tablet | Emergency Contraceptive for Women",
//         //           displayText:
//         //             "<strong>i-pill Tablet</strong> is an emergency contraceptive tablet used to prevent unintended pregnancy in the event of unprotected intercourse or failure of contraception. It contains Levonorgestrel, a synthetic hormone that is similar to the naturally occurring hormone progesterone. The tablet works by preventing the release of an egg from the ovary or by keeping the sperm from combining with the egg.<br /><br /><strong>Key Ingredients:</strong><br /><ul><li>Levonorgestrel IP: 1.5 mg</li></ul><br /><strong>Key Benefits:</strong><br /><ul><li>It may help in preventing unintended pregnancy in the event of unprotected intercourse</li></ul><ul><li>It provides a backup option for contraception in case of failure of other methods</li></ul><ul><li>This tablet offers a convenient option for emergency contraception that can be taken within 72 hours after unprotected intercourse</li></ul><br /><strong>Good to Know:</strong><br />The primary use of the i-pill is for emergency contraception in the event of unprotected intercourse or contraception failure.<br /><br /><strong>Concerns It Can Help With:</strong><br /><ul><li>Contraception</li></ul><br /><strong>Product Form:</strong> Tablet<br /><br /><strong>Directions for Use:</strong><br />Take one pill as soon as possible, but no later than 72 hours of unprotected sex to prevent unwanted pregnancy.<br /><br /><strong>Safety Information:</strong><br /><ul><li>Store protected from light and moisture</li></ul><ul><li>I-pill should not be used as a substitute for condoms or any regular contraceptive method</li></ul><ul><li>I-pill does not prevent the transmission of STD or HIV/AIDS</li></ul><ul><li>Read the label carefully before use</li></ul><ul><li>Keep out of the reach of children</li></ul><ul><li>Store in a cool and dry place</li></ul>",
//         //         },
//         //         rating: {
//         //           overallRating: {
//         //             value: "4.4",
//         //             displayText: "Based on 1210 Ratings",
//         //           },
//         //           values: [
//         //             { rating: 5, value: 72 },
//         //             { rating: 4, value: 16 },
//         //             { rating: 3, value: 4 },
//         //             { rating: 2, value: 1 },
//         //             { rating: 1, value: 7 },
//         //           ],
//         //         },
//         //         highlights: {
//         //           displayText:
//         //             "<ul><li>Prevents unintended pregnancy</li></ul><ul><li>Convenient to use</li></ul><ul><li>Works as an emergency contraceptive pill</li></ul><ul><li>Contains levonorgestrel as an active ingredient</li></ul>",
//         //         },
//         //         vendors:
//         //           "Country of origin: India<br><b>Expires on or after: </b> May, 2026",
//         //       },
//         //     },
//         //   },
//         // };

//         // setProductData(mockResponse.data);
//       } catch (error) {
//         console.error("Error fetching product data:", error);
//         setLoading(false);
//       }
//     };

//     fetchProductData(id);
//   }, []);

//   const nextImage = () => {
//     if (productData?.detailJson?.skus?.images) {
//       setSelectedImageIndex((prev) =>
//         prev === productData.detailJson.skus.images.length - 1 ? 0 : prev + 1
//       );
//     }
//   };

//   const prevImage = () => {
//     if (productData?.detailJson?.skus?.images) {
//       setSelectedImageIndex((prev) =>
//         prev === 0 ? productData.detailJson.skus.images.length - 1 : prev - 1
//       );
//     }
//   };

//   const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 !== 0;

//     for (let i = 0; i < 5; i++) {
//       if (i < fullStars) {
//         stars.push(
//           <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
//         );
//       } else if (i === fullStars && hasHalfStar) {
//         stars.push(
//           <Star
//             key={i}
//             className="h-4 w-4 fill-yellow-400 text-yellow-400"
//             style={{ clipPath: "inset(0 50% 0 0)" }}
//           />
//         );
//       } else {
//         stars.push(<Star key={i} className="h-4 w-4 text-gray-300" />);
//       }
//     }
//     return stars;
//   };

//   if (loading) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gray-50">
//         <div className="flex animate-pulse space-x-4">
//           <div className="h-4 w-4 rounded-full bg-blue-500"></div>
//           <div className="h-4 w-4 rounded-full bg-blue-500"></div>
//           <div className="h-4 w-4 rounded-full bg-blue-500"></div>
//         </div>
//       </div>
//     );
//   }

//   if (!productData) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gray-50">
//         <div className="text-center">
//           <AlertCircle className="mx-auto mb-4 h-16 w-16 text-red-500" />
//           <h2 className="mb-2 text-2xl font-bold text-gray-900">
//             Product Not Found
//           </h2>
//           <p className="text-gray-600">Unable to load product information.</p>
//         </div>
//       </div>
//     );
//   }

//   const product = productData.detailJson.skus;

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <header className="border-b bg-white shadow-sm">
//         <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <button className="rounded-full p-2 hover:bg-gray-100">
//                 <ChevronLeft className="h-6 w-6" />
//               </button>
//               <h1 className="truncate text-lg font-medium text-gray-900">
//                 {product.name}
//               </h1>
//             </div>
//             <div className="flex items-center space-x-2">
//               <button className="rounded-full p-2 hover:bg-gray-100">
//                 <Share2 className="h-5 w-5" />
//               </button>
//               <button className="rounded-full p-2 hover:bg-gray-100">
//                 <Heart className="h-5 w-5" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
//         <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-12">
//           {/* Product Images */}
//           <div className="mb-8 lg:mb-0">
//             <div className="relative">
//               <div className="aspect-square overflow-hidden rounded-2xl bg-white shadow-lg">
//                 <img
//                   src={
//                     product.images[selectedImageIndex]?.high ||
//                     product.images[0]?.high
//                   }
//                   alt={product.name}
//                   className="h-full w-full object-contain"
//                 />
//                 {product.images.length > 1 && (
//                   <>
//                     <button
//                       onClick={prevImage}
//                       className="absolute left-4 top-1/2 -translate-y-1/2 transform rounded-full bg-white/80 p-2 shadow-md transition-all hover:bg-white"
//                     >
//                       <ChevronLeft className="h-5 w-5" />
//                     </button>
//                     <button
//                       onClick={nextImage}
//                       className="absolute right-4 top-1/2 -translate-y-1/2 transform rounded-full bg-white/80 p-2 shadow-md transition-all hover:bg-white"
//                     >
//                       <ChevronRight className="h-5 w-5" />
//                     </button>
//                   </>
//                 )}
//               </div>

//               {/* Thumbnail Images */}
//               {product.images.length > 1 && (
//                 <div className="mt-4 flex space-x-2 overflow-x-auto">
//                   {product.images.map((image, index) => (
//                     <button
//                       key={index}
//                       onClick={() => setSelectedImageIndex(index)}
//                       className={`h-16 w-16 flex-shrink-0 overflow-hidden rounded-lg border-2 transition-all ${
//                         index === selectedImageIndex
//                           ? "border-blue-500"
//                           : "border-gray-200"
//                       }`}
//                     >
//                       <img
//                         src={image.thumbnail}
//                         alt={`Product ${index + 1}`}
//                         className="h-full w-full bg-white object-contain"
//                       />
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Product Info */}
//           <div className="space-y-6">
//             {/* Title and Rating */}
//             <div>
//               <h1 className="mb-2 text-2xl font-bold text-gray-900 lg:text-3xl">
//                 {product.name}
//               </h1>
//               <div className="mb-4 flex items-center space-x-2">
//                 <div className="flex items-center">
//                   {renderStars(parseFloat(product.rating.overallRating.value))}
//                 </div>
//                 <span className="text-sm text-gray-600">
//                   {product.rating.overallRating.value} (
//                   {product.rating.overallRating.displayText})
//                 </span>
//               </div>
//               <p className="mb-4 text-sm text-gray-600">
//                 {product.standardPackLabel}
//               </p>
//             </div>

//             {/* Price */}
//             <div className="rounded-xl border bg-white p-6 shadow-sm">
//               <div className="mb-2 flex items-center space-x-3">
//                 <span className="text-3xl font-bold text-gray-900">
//                   ₹{product.discountedPrice}
//                 </span>
//                 {product.price !== product.discountedPrice && (
//                   <span className="text-lg text-gray-500 line-through">
//                     ₹{product.price}
//                   </span>
//                 )}
//               </div>
//               <p className="text-sm text-gray-600">
//                 {product.tax_inclusion_text}
//               </p>
//             </div>

//             {/* Key Features */}
//             <div className="rounded-xl border border-blue-100 bg-gradient-to-br from-blue-50 to-indigo-50 p-6">
//               <h3 className="mb-3 flex items-center font-semibold text-gray-900">
//                 <CheckCircle className="mr-2 h-5 w-5 text-blue-600" />
//                 Key Features
//               </h3>
//               <div
//                 className="space-y-1 text-sm text-gray-700"
//                 dangerouslySetInnerHTML={{
//                   __html: product.highlights.displayText,
//                 }}
//               />
//             </div>

//             {/* Quantity and Add to Cart */}
//             <div className="space-y-4">
//               <div className="flex items-center space-x-4">
//                 <span className="text-sm font-medium text-gray-700">
//                   Quantity:
//                 </span>
//                 <div className="flex items-center rounded-lg border border-gray-300">
//                   <button
//                     onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                     className="rounded-l-lg p-2 hover:bg-gray-100"
//                     disabled={quantity <= 1}
//                   >
//                     <Minus className="h-4 w-4" />
//                   </button>
//                   <span className="min-w-[3rem] px-4 py-2 text-center">
//                     {quantity}
//                   </span>
//                   <button
//                     onClick={() => setQuantity(quantity + 1)}
//                     className="rounded-r-lg p-2 hover:bg-gray-100"
//                   >
//                     <Plus className="h-4 w-4" />
//                   </button>
//                 </div>
//               </div>

//               <button className="flex w-full items-center justify-center space-x-2 rounded-xl bg-blue-600 py-4 px-6 font-medium text-white transition-colors hover:bg-blue-700">
//                 <ShoppingCart className="h-5 w-5" />
//                 <span>Add to Cart</span>
//               </button>
//             </div>

//             {/* Delivery Info */}
//             <div className="space-y-4 rounded-xl border bg-white p-6 shadow-sm">
//               <div className="flex items-center space-x-3">
//                 <Truck className="h-5 w-5 text-green-600" />
//                 <div>
//                   <p className="font-medium text-gray-900">Free Delivery</p>
//                   <p className="text-sm text-gray-600">
//                     Cash on delivery available
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-center space-x-3">
//                 <Shield className="h-5 w-5 text-blue-600" />
//                 <div>
//                   <p className="font-medium text-gray-900">Authentic Product</p>
//                   <p className="text-sm text-gray-600">
//                     Licensed vendor partner
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-center space-x-3">
//                 <Clock className="h-5 w-5 text-orange-600" />
//                 <div>
//                   <p className="font-medium text-gray-900">
//                     Emergency Contraceptive
//                   </p>
//                   <p className="text-sm text-gray-600">Take within 72 hours</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Product Information Tabs */}
//         <div className="mt-12">
//           <div className="border-b border-gray-200">
//             <nav className="-mb-px flex space-x-8 overflow-x-auto">
//               {["description", "specifications", "reviews"].map((tab) => (
//                 <button
//                   key={tab}
//                   onClick={() => setActiveTab(tab)}
//                   className={`whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium ${
//                     activeTab === tab
//                       ? "border-blue-500 text-blue-600"
//                       : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
//                   }`}
//                 >
//                   {tab.charAt(0).toUpperCase() + tab.slice(1)}
//                 </button>
//               ))}
//             </nav>
//           </div>

//           <div className="mt-8">
//             {activeTab === "description" && (
//               <div className="rounded-xl border bg-white p-6 shadow-sm">
//                 <h3 className="mb-4 text-lg font-semibold text-gray-900">
//                   {product.description.header}
//                 </h3>
//                 <div
//                   className="prose max-w-none text-gray-700"
//                   dangerouslySetInnerHTML={{
//                     __html: showFullDescription
//                       ? product?.description?.displayText
//                       : product?.description?.displayText?.substring(0, 500) +
//                         "...",
//                   }}
//                 />
//                 {product.description.displayText.length > 500 && (
//                   <button
//                     onClick={() => setShowFullDescription(!showFullDescription)}
//                     className="mt-4 font-medium text-blue-600 hover:text-blue-700"
//                   >
//                     {showFullDescription ? "Show Less" : "Show More"}
//                   </button>
//                 )}
//               </div>
//             )}

//             {activeTab === "specifications" && (
//               <div className="rounded-xl border bg-white p-6 shadow-sm">
//                 <h3 className="mb-4 text-lg font-semibold text-gray-900">
//                   Product Specifications
//                 </h3>
//                 <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
//                   <div className="space-y-3">
//                     <div className="flex justify-between border-b border-gray-100 py-2">
//                       <span className="font-medium text-gray-600">
//                         Manufacturer
//                       </span>
//                       <span className="text-gray-900">
//                         {product.marketer.name}
//                       </span>
//                     </div>
//                     <div className="flex justify-between border-b border-gray-100 py-2">
//                       <span className="font-medium text-gray-600">
//                         Pack Size
//                       </span>
//                       <span className="text-gray-900">
//                         {product.standardPack}
//                       </span>
//                     </div>
//                     <div className="flex justify-between border-b border-gray-100 py-2">
//                       <span className="font-medium text-gray-600">
//                         Product Form
//                       </span>
//                       <span className="text-gray-900">Tablet</span>
//                     </div>
//                     <div className="flex justify-between py-2">
//                       <span className="font-medium text-gray-600">
//                         Country of Origin
//                       </span>
//                       <span className="text-gray-900">India</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {activeTab === "reviews" && (
//               <div className="rounded-xl border bg-white p-6 shadow-sm">
//                 <h3 className="mb-6 text-lg font-semibold text-gray-900">
//                   Customer Reviews
//                 </h3>

//                 {/* Rating Summary */}
//                 <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-2">
//                   <div className="text-center">
//                     <div className="mb-2 text-4xl font-bold text-gray-900">
//                       {product.rating.overallRating.value}
//                     </div>
//                     <div className="mb-2 flex justify-center">
//                       {renderStars(
//                         parseFloat(product.rating.overallRating.value)
//                       )}
//                     </div>
//                     <p className="text-sm text-gray-600">
//                       {product.rating.overallRating.displayText}
//                     </p>
//                   </div>

//                   <div className="space-y-2">
//                     {product.rating.values.map((rating) => (
//                       <div
//                         key={rating.rating}
//                         className="flex items-center space-x-3"
//                       >
//                         <span className="w-2 text-sm font-medium">
//                           {rating.rating}
//                         </span>
//                         <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
//                         <div className="h-2 flex-1 rounded-full bg-gray-200">
//                           <div
//                             className="h-2 rounded-full bg-yellow-400"
//                             style={{ width: `${rating.value}%` }}
//                           ></div>
//                         </div>
//                         <span className="w-8 text-sm text-gray-600">
//                           {rating.value}%
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Important Warning */}
//         <div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-6">
//           <div className="flex items-start space-x-3">
//             <AlertCircle className="mt-0.5 h-6 w-6 flex-shrink-0 text-red-600" />
//             <div>
//               <h4 className="mb-2 font-semibold text-red-900">
//                 Important Safety Information
//               </h4>
//               <ul className="space-y-1 text-sm text-red-800">
//                 <li>
//                   • This is an emergency contraceptive - not for regular use
//                 </li>
//                 <li>
//                   • Take within 72 hours of unprotected intercourse for maximum
//                   effectiveness
//                 </li>
//                 <li>
//                   • Does not protect against sexually transmitted infections
//                 </li>
//                 <li>• Consult a healthcare provider if you have concerns</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OtcProductIndividualpage;

import React, { useState, useEffect } from "react";
import {
  Star,
  ShoppingCart,
  Heart,
  Share2,
  Truck,
  Shield,
  Clock,
  ChevronLeft,
  ChevronRight,
  Plus,
  Minus,
  AlertCircle,
  CheckCircle,
} from "lucide-react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const OtcProductIndividualpage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState("description");
  const [showFullDescription, setShowFullDescription] = useState(false);

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const res = await axios.get(
          `https://api.medstown.com/api/medshubs/otc-product/${id}`
        );
        console.log(res.data?.data);
        setProductData(res.data?.data);
      } catch (error) {
        console.error("Error fetching product data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductData();
  }, [id]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="flex animate-pulse space-x-4">
          <div className="h-4 w-4 rounded-full bg-blue-500"></div>
          <div className="h-4 w-4 rounded-full bg-blue-500"></div>
          <div className="h-4 w-4 rounded-full bg-blue-500"></div>
        </div>
      </div>
    );
  }

  if (!productData) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <AlertCircle className="mx-auto mb-4 h-16 w-16 text-red-500" />
          <h2 className="mb-2 text-2xl font-bold text-gray-900">
            Product Not Found
          </h2>
          <p className="text-gray-600">Unable to load product information.</p>
        </div>
      </div>
    );
  }

  const product = productData?.detailJson?.skus || {};
  const {
    rating = {},
    highlights = {},
    description = {},
    marketer = {},
    images = [],
    name = "Unnamed Product",
    price = 0,
    discountedPrice = 0,
    standardPack = "",
    standardPackLabel = "",
    tax_inclusion_text = "",
  } = product;

  const renderStars = (ratingValue) => {
    const stars = [];
    const fullStars = Math.floor(ratingValue);
    const hasHalfStar = ratingValue % 1 !== 0;
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
        );
      } else if (i === fullStars && hasHalfStar) {
        stars.push(
          <Star
            key={i}
            className="h-4 w-4 fill-yellow-400 text-yellow-400"
            style={{ clipPath: "inset(0 50% 0 0)" }}
          />
        );
      } else {
        stars.push(<Star key={i} className="h-4 w-4 text-gray-300" />);
      }
    }
    return stars;
  };

  const handleImageChange = (direction) => {
    if (!images.length) return;
    setSelectedImageIndex((prev) => {
      const last = images.length - 1;
      return direction === "prev"
        ? prev === 0
          ? last
          : prev - 1
        : prev === last
        ? 0
        : prev + 1;
    });
  };

  const getCleanImageURL = (url, fallback = null) => {
    if (!url) return fallback;

    const croppedMatch = url.match(/\/cropped\/[a-z0-9]+\.(jpg|png|webp)/i);
    if (croppedMatch) {
      return `https://onemg.gumlet.io${croppedMatch[0]}`;
    }

    const fileMatch = url.match(/\/([a-z0-9]+)\.(jpg|png|webp)/i);
    if (fileMatch) {
      return `https://onemg.gumlet.io/${fileMatch[1]}.${fileMatch[2]}`;
    }

    return fallback;
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="rounded-full p-2 hover:bg-gray-100"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <h1 className="text-lg font-semibold">{name}</h1>
        </div>
        <div className="flex gap-2">
          <button className="rounded-full p-2 hover:bg-gray-100">
            <Share2 className="h-5 w-5" />
          </button>
          <button className="rounded-full p-2 hover:bg-gray-100">
            <Heart className="h-5 w-5" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        {/* Images */}
        <div>
          <div className="relative overflow-hidden rounded-xl bg-white shadow">
            <img
              src={
                getCleanImageURL(images[selectedImageIndex]?.high) ||
                images[0]?.high ||
                "/placeholder.jpg"
              }
              alt={name}
              className="w-full object-contain"
            />

            {images.length > 1 && (
              <>
                <button
                  onClick={() => handleImageChange("prev")}
                  className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white p-2 shadow"
                >
                  <ChevronLeft className="h-4 w-4" />
                </button>
                <button
                  onClick={() => handleImageChange("next")}
                  className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white p-2 shadow"
                >
                  <ChevronRight className="h-4 w-4" />
                </button>
              </>
            )}
          </div>

          {/* Thumbnails */}
          {images.length > 1 && (
            <div className="mt-4 flex gap-2 overflow-x-auto">
              {images.map((img, i) => (
                <img
                  key={i}
                  onClick={() => setSelectedImageIndex(i)}
                  src={getCleanImageURL(img.thumbnail)}
                  className={`h-16 w-16 rounded-lg border-2 object-contain ${
                    selectedImageIndex === i
                      ? "border-blue-500"
                      : "border-gray-200"
                  }`}
                  alt={`thumb-${i}`}
                />
              ))}
            </div>
          )}
        </div>

        {/* Details */}
        <div className="space-y-4">
          <h2 className="text-xl font-bold">{name}</h2>
          {rating?.overallRating?.value ? (
            <div className="flex items-center gap-2">
              {renderStars(parseFloat(rating.overallRating.value))}
              <span className="text-sm text-gray-600">
                {rating.overallRating.value} ({rating.overallRating.displayText}
                )
              </span>
            </div>
          ) : (
            <p className="text-sm text-gray-500">No ratings available</p>
          )}

          <p className="text-sm text-gray-600">{standardPackLabel}</p>

          <div className="rounded-xl border bg-white p-4 shadow">
            <div className="flex items-center gap-4">
              <span className="text-2xl font-bold text-gray-900">
                ₹{discountedPrice}
              </span>
              {price !== discountedPrice && (
                <span className="text-lg text-gray-500 line-through">
                  ₹{price}
                </span>
              )}
            </div>
            <p className="mt-1 text-sm text-gray-500">{tax_inclusion_text}</p>
          </div>

          {/* Key Features */}
          {highlights?.displayText && (
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <h3 className="mb-2 flex items-center font-semibold text-blue-700">
                <CheckCircle className="mr-2 h-4 w-4" />
                Key Features
              </h3>
              <div
                className="space-y-1 text-sm text-gray-700"
                dangerouslySetInnerHTML={{
                  __html: highlights.displayText,
                }}
              />
            </div>
          )}

          {/* Quantity & Button */}
          {/* <div className="flex items-center gap-4">
            <span className="text-sm font-medium text-gray-700">Quantity:</span>
            <div className="flex border rounded-lg overflow-hidden">
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                disabled={quantity <= 1}
                className="p-2 hover:bg-gray-100 disabled:opacity-40"
              >
                <Minus className="h-4 w-4" />
              </button>
              <span className="px-4 py-2">{quantity}</span>
              <button
                onClick={() => setQuantity(quantity + 1)}
                className="p-2 hover:bg-gray-100"
              >
                <Plus className="h-4 w-4" />
              </button>
            </div>
          </div> */}
          {/* 
          <button className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-3 flex items-center justify-center gap-2">
            <ShoppingCart className="h-5 w-5" />
            Add to Cart
          </button> */}
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-10">
        <div className="flex gap-4 border-b">
          {["description", "specifications", "reviews"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`border-b-2 py-2 px-1 text-sm font-medium ${
                activeTab === tab
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:border-gray-300"
              }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>

        <div className="mt-6">
          {activeTab === "description" && (
            <div className="rounded-xl bg-white p-6 shadow">
              <h4 className="mb-2 text-lg font-semibold">
                {description?.header || "Product Description"}
              </h4>
              <div
                className="prose text-gray-700"
                dangerouslySetInnerHTML={{
                  __html: showFullDescription
                    ? description?.displayText
                    : (description?.displayText || "").slice(0, 500) + "...",
                }}
              />
              {description?.displayText?.length > 500 && (
                <button
                  onClick={() => setShowFullDescription(!showFullDescription)}
                  className="mt-3 text-sm text-blue-600 hover:underline"
                >
                  {showFullDescription ? "Show Less" : "Show More"}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtcProductIndividualpage;
